var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 48,
    viewBox: "0 0 57 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8847 21.7742C30.0831 21.7543 30.3211 21.7543 30.5394 21.7742C35.2611 21.6155 39.0107 17.7468 39.0107 12.9854C39.0107 8.12477 35.0826 4.17676 30.2021 4.17676C25.3415 4.17676 21.3935 8.12477 21.3935 12.9854C21.4133 17.7468 25.1629 21.6155 29.8847 21.7742Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5011 8.14551C11.6523 8.14551 8.55738 11.2603 8.55738 15.0893C8.55738 18.8389 11.5333 21.8941 15.2432 22.033C15.4019 22.0132 15.5805 22.0132 15.759 22.033",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4464 8.14551C48.2952 8.14551 51.3901 11.2603 51.3901 15.0893C51.3901 18.8389 48.4142 21.8941 44.7043 22.033C44.5456 22.0132 44.367 22.0132 44.1885 22.033",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8042 29.096C44.6053 32.3099 44.6053 37.5475 39.8042 40.7416C34.3484 44.3921 25.4009 44.3921 19.9451 40.7416C15.144 37.5277 15.144 32.2901 19.9451 29.096C25.3811 25.4654 34.3286 25.4654 39.8042 29.096Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6726 39.8879C10.2442 39.5903 8.89511 39.015 7.78411 38.1619C4.68919 35.8407 4.68919 32.0117 7.78411 29.6906C8.87527 28.8573 10.2045 28.3018 11.6131 27.9844",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2749 39.8879C49.7033 39.5903 51.0524 39.015 52.1634 38.1619C55.2583 35.8407 55.2583 32.0117 52.1634 29.6906C51.0722 28.8573 49.743 28.3018 48.3344 27.9844",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnal);
export default __webpack_public_path__ + "static/media/thumbnal.07fb971fce02f9284071c0d95738efbb.svg";
export { ForwardRef as ReactComponent };